class ColorSwatchOptions extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Wait for the next tick to ensure children are rendered
    setTimeout(() => {
      this.swatches = this.querySelectorAll('.plp-mapped-colors__swatch');
      this.productCard = this.closest('.card-wrapper');
      this.init();
    }, 0);
  }

  init() {
    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', this.handleSwatchClick.bind(this));
    });
  }

  handleSwatchClick(event) {
    const swatch = event.currentTarget;
    if (swatch.disabled) return;

    // Update current selection
    this.updateSelection(swatch);

    // Update product card content using data attributes
    this.updateProductCardFromData(swatch);

    // Update variant options (sizes)
    this.updateVariantOptionsFromData(swatch);
  }

  updateSelection(selectedSwatch) {
    // Remove is-selected from all swatches
    this.swatches.forEach(swatch => {
      swatch.classList.remove('is-selected');
      swatch.disabled = false;
    });
    
    // Add is-selected to clicked swatch
    selectedSwatch.classList.add('is-selected');
    selectedSwatch.disabled = true;
  }

  updateProductCardFromData(swatch) {
    if (!this.productCard) return;

    // Update title href if provided
    const productUrl = swatch.getAttribute('data-product-url');
    if (productUrl) {
      // Update ALL product card links, not just the first one
      const titleLinks = this.productCard.querySelectorAll('.product-card-link, .quickshop__option-variant-link');
      titleLinks.forEach(link => {
        link.href = productUrl;
      });
    }

    // Update images
    this.updateImagesFromData(swatch);

    // Update price
    this.updatePriceFromData(swatch);
  }

  updateVariantOptionsFromData(swatch) {
    if (!this.productCard) return;

    const container = this.productCard.querySelector('.product__variant-options');
    if (!container) return;

    const raw = swatch.getAttribute('data-variants');
    if (!raw) return;

    let variants;
    try {
      variants = JSON.parse(raw);
    } catch (err) {
      try {
        variants = JSON.parse(raw.replace(/&quot;/g, '"'));
      } catch (e) {
        return;
      }
    }

    if (!Array.isArray(variants) || variants.length === 0) return;

    const productUrl = swatch.getAttribute('data-product-url') || '';

    const html = variants
      .map(variant => {
        const classes = [
          'option-value-wrapper',
          'quickshop__option-variant-link',
          'product__option-input-wrapper'
        ];
        if (!variant.available) classes.push('is-disabled');

        const size = (variant.title || '').toString();
        const href = productUrl ? `${productUrl}?variant=${variant.id}` : '#';
        const ariaDisabled = variant.available ? '' : ' aria-disabled="true"';
        return `<a href="${href}" class="${classes.join(' ')}" data-size-link data-size="${this.escapeHtml(size)}"${ariaDisabled}><span class="option-value" aria-hidden="true">${this.escapeHtml(size)}</span></a>`;
      })
      .join('');

    container.innerHTML = html;
  }

  updateImagesFromData(swatch) {
    // Primary image
    const featuredImg = this.productCard.querySelector('.card__media .media img');
    if (featuredImg) {
      const src = swatch.getAttribute('data-featured-src');
      const srcset = swatch.getAttribute('data-featured-srcset');
      const alt = swatch.getAttribute('data-featured-alt');
      const width = swatch.getAttribute('data-featured-width');
      const height = swatch.getAttribute('data-featured-height');
      if (src) featuredImg.src = src;
      if (srcset) featuredImg.srcset = srcset;
      if (alt) featuredImg.alt = alt;
      if (width) featuredImg.width = parseInt(width, 10);
      if (height) featuredImg.height = parseInt(height, 10);
    }

    // Secondary image (if present in DOM)
    const images = this.productCard.querySelectorAll('.card__media .media img');
    const secondaryImg = images.length > 1 ? images[1] : null;
    if (secondaryImg) {
      const sSrc = swatch.getAttribute('data-secondary-src');
      const sSrcset = swatch.getAttribute('data-secondary-srcset');
      const sAlt = swatch.getAttribute('data-secondary-alt');
      const sWidth = swatch.getAttribute('data-secondary-width');
      const sHeight = swatch.getAttribute('data-secondary-height');
      if (sSrc) secondaryImg.src = sSrc;
      if (sSrcset) secondaryImg.srcset = sSrcset;
      if (sAlt) secondaryImg.alt = sAlt;
      if (sWidth) secondaryImg.width = parseInt(sWidth, 10);
      if (sHeight) secondaryImg.height = parseInt(sHeight, 10);
    }
  }

  updatePriceFromData(swatch) {
    const priceElement = this.productCard.querySelector('.price');
    if (!priceElement) return;

    const priceCents = parseInt(swatch.getAttribute('data-price') || '0', 10);
    const compareAtCents = parseInt(swatch.getAttribute('data-compare-at-price') || '0', 10);

    const priceRegular = priceElement.querySelector('.price-item--regular');
    const priceSale = priceElement.querySelector('.price-item--sale');

    if (compareAtCents > priceCents) {
      priceElement.classList.add('price--on-sale');
      if (priceSale) priceSale.textContent = this.formatMoney(priceCents);
      if (priceRegular) priceRegular.textContent = this.formatMoney(compareAtCents);
    } else {
      priceElement.classList.remove('price--on-sale');
      if (priceRegular) priceRegular.textContent = this.formatMoney(priceCents);
      if (priceSale) priceSale.textContent = '';
    }
  }

  formatMoney(cents) {
    // Use Shopify's money format if available, otherwise fallback
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }

    const currency = window.Shopify.currency.active;

    return (cents / 100).toFixed(0) + ' ' + currency;
  }

  escapeHtml(str) {
    if (typeof str !== 'string') return '';
    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}

customElements.define('plp-mapped-product-colors', ColorSwatchOptions);